define('LNRS/Track/AnalyticsDispatcher',[
    "jquery",
    "eventManager",
    "Utility/UrlHelper",
    "Track/DataLayerManager",
    "Track/Events",
    "Track/TrackVideos",
    "Track/TrackNavigation",
    "Track/TrackLinks",
    "Track/TrackScroll",
    "Track/TrackSearches",
    "Track/TrackPageEvents",
    "Track/TrackForms",
    "Track/TrackBounceRate"
], function (
    $,
    eventManager,
    urlHelper,
    dlmanager,
    events,
    trackVideos,
    trackNavigation,
    trackLinks,
    trackScroll,
    trackSearches,
    trackPageEvents,
    trackForms,
    trackBounceRate
) {

    var dictionary = { talkToSupport: "32C2F5AA-8D13-4253-85DF-6881ABA3A148" },
        reservedSegments = ["global", "en", "pt", "es", "fr", "de", "zh"];

    function trackPhraseInteraction() {
        $(document).on("click", "span.dictionary-item", function (ev) {
            var $el = $(ev.target), o = { site_events: {} };
            if ($el.attr("data-id") === dictionary.talkToSupport) {
                o.site_events["call_sales_support"] = "true";
                o["event_name"] = "click to call";
                dlmanager.trackAnalytics(o);
            }
        });
    }

    function trackTabs() {
        $(".score-tab").on("shown.bs.tab", function (ev) {
            var o = {
                site_events: { "content_tab_click": "true" },
                event_name: "toggle tabs",
                tab_identifier: $(ev.target).text().replace(/\s\s+/g, " ")
            };

            dlmanager.trackAnalytics(o);
        });
        }

        function trackAccordion() {
            $(".score-accordion .panel .panel-heading").click(function () {
                if ($(this).find('a').hasClass('collapsed')) {
                    var o = { site_events: {} };
                    o.site_events["accordion_click"] = "true";
                    o["event_name"] = "accordion click";
                    o["panel_identifier"] = $(this).text().replace(/\u2013/g, '-').replace(/\t/g, ' ').replace(/\s\s+/g, " ").replace(/[^a-zA-Z0-9 .,\-]/g, '').trim();
                    dlmanager.trackAnalytics(o);
                }
            });
        }

    function AnalyticsDispatcher(pageId, templateId, title, parentTitle, msid, time, ip, lang, type, regionName, industrySearchTags, solutionSearchTags, industryName, subIndustrySearchTags, subIndustryName) {
        var modLoadDef = $.Deferred();
        var bounceRatePromise  = trackBounceRate(pageId);

        var pageEventsPromise = templateId === "DB6EFB43-3022-46F4-876C-C49F88684A69" //Search Page
            ? trackSearches() // async
            : trackPageEvents(pageId, templateId, title, parentTitle, type, industrySearchTags, solutionSearchTags, industryName, subIndustrySearchTags, subIndustryName); // sync

        eventManager.subscribe("ModulesLoadedEvent", modLoadDef.resolve.bind(modLoadDef));

        // Tell the analytics script that all page events have run and all components have loaded
        $.when(pageEventsPromise, modLoadDef.promise()).then(function () {
            dlmanager.dataLayerReady();

            trackVideos();
            trackNavigation();
            trackLinks();
            trackForms();
            trackPhraseInteraction();
            trackTabs();
            trackAccordion();
        });
    }

    return function initAnalyticsDispatcher(args) {
        if (args.IsExperienceEditorEditing === true) {
            return null;
        }

        return new AnalyticsDispatcher(
            args.PageId,
            args.TemplateId,
            args.DefaultTitle,
            args.ParentDefaultTitle || "",
            args.MSID || "",
            args.CurrentEasternTime,
            args.UserHostAddress,
            args.LanguageName,
            args.ResourceType,
            args.RegionName,
            args.industrySearchTags,
            args.solutionSearchTags,
            args.industryName,
            args.subIndustrySearchTags,
            args.subIndustryName
        );
    };
});

